document.addEventListener('DOMContentLoaded', function () {
  const shareButton = document.getElementById('ProductShareButton');

  if (!shareButton) return;

  async function shareProduct() {
    const shareData = {
      title: document.title,
      text: 'Schau dir dieses Produkt an:',
      url: window.location.href
    };

    // Mobile / supported browsers
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (error) {
        // User closed the share popup
        if (error.name !== 'AbortError') {
          console.error('Share failed:', error);
        }
      }

      return;
    }

    // Desktop / unsupported browsers
    try {
      await navigator.clipboard.writeText(window.location.href);

      shareButton.classList.add('link-copied');

      const tooltip = shareButton.querySelector('.tooltip-text');

      if (tooltip) {
        const oldText = tooltip.textContent;
        tooltip.textContent = 'Link kopiert!';

        setTimeout(() => {
          tooltip.textContent = oldText;
          shareButton.classList.remove('link-copied');
        }, 2000);
      }
    } catch (error) {
      console.error('Could not copy product URL:', error);
    }
  }

  shareButton.addEventListener('click', shareProduct);

  // Also allow keyboard access
  shareButton.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      shareProduct();
    }
  });
});